import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, vModelRadio as _vModelRadio, createBlock as _createBlock, withKeys as _withKeys } from "vue";
const _hoisted_1 = ["tabindex"];
const _hoisted_2 = ["title"];
const _hoisted_3 = {
    key: 0,
    class: "catalog-search-input-filter__caret"
};
const _hoisted_4 = {
    key: 0,
    class: "catalog-search-input-filter__dropdown"
};
const _hoisted_5 = { class: "catalog-search-input-filter__dropdown-title" };
const _hoisted_6 = { class: "catalog-search-input-filter__controls" };
const _hoisted_7 = { class: "catalog-search-input-filter__range-value catalog-search-input-filter__range-value--min" };
const _hoisted_8 = ["type"];
const _hoisted_9 = { class: "catalog-search-input-filter__range-value catalog-search-input-filter__range-value--max" };
const _hoisted_10 = ["type"];
const _hoisted_11 = { class: "catalog-search-input-filter__controls" };
const _hoisted_12 = { class: "catalog-search-input-filter__bool" };
const _hoisted_13 = { class: "catalog-search-input-filter__bool-value" };
const _hoisted_14 = ["name"];
const _hoisted_15 = { class: "catalog-search-input-filter__bool-value" };
const _hoisted_16 = ["name"];
const _hoisted_17 = { class: "catalog-search-input-filter__controls" };
const _hoisted_18 = { class: "catalog-search-input-filter__values" };
const _hoisted_19 = { class: "catalog-search-input-filter__buttons" };
import { computed, ref } from 'vue';
import { useClickaway } from "@astina/paloma-common-ui/src/composables/clickaway";
import CatalogSearchFilterInputValue from "./CatalogSearchFilterInputValue.vue";
import portalConfig from "../services/PortalConfig";
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CatalogSearchInputFilter',
    props: {
        filter: {},
        searchRequest: {}
    },
    emits: ['update'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const showDropdown = ref(false);
        const el = ref(null);
        useClickaway(el, () => showDropdown.value = false);
        const activeValues = computed(() => props.filter.values.filter(isActiveValue));
        const selectedValues = ref(props.filter.values.filter(isActiveValue));
        const filterValues = computed(sortedFilterValues);
        const totalResults = computed(calculateTotalResults);
        const hidden = computed(isFilterHidden);
        const disabled = computed(isFilterDisabled);
        const active = computed(isActive);
        // range filters
        const isRangeFilter = computed(() => {
            return props.filter.type === 'currency'
                || props.filter.type === 'number'
                || props.filter.type === 'date';
        });
        const activeRange = computed(createActiveRange);
        const selectedRange = ref(createSelectedRange());
        const rangeUpdated = ref(false);
        const rangeFilterInput = computed(() => {
            return props.filter.type === 'date' ? 'date' : 'number';
        });
        // boolean filter
        const activeBoolean = computed(isBooleanFilterSelected);
        const selectedBoolean = ref(activeBoolean.value);
        function toggleFilterValue(value) {
            const selected = selectedValues.value.find(val => (value.valueCode || value.value) === (val.valueCode || val.value));
            if (selected) {
                const index = selectedValues.value.indexOf(selected);
                selectedValues.value.splice(index, 1);
            }
            else {
                selectedValues.value.push(value);
            }
        }
        function emitUpdate() {
            emit('update', props.filter, updateEventArg());
        }
        function updateEventArg() {
            if (props.filter.type === 'date') {
                return selectedDateRangeValues();
            }
            if (isRangeFilter.value) {
                return selectedRange.value;
            }
            if (props.filter.type === 'bool') {
                return selectedBoolean.value;
            }
            return selectedValues.value;
        }
        function update() {
            emitUpdate();
            showDropdown.value = false;
        }
        function close() {
            clear();
        }
        function clear() {
            selectedValues.value = [];
            selectedRange.value = { min: null, max: null };
            selectedBoolean.value = null;
            emitUpdate();
            showDropdown.value = false;
        }
        function selectAll() {
            selectedValues.value = props.filter.values.filter(val => val.count > 0);
        }
        function isFilterValueSelected(value) {
            return !!selectedValues.value.find(v => (v.valueCode !== null && v.valueCode === value.valueCode) || (v.value === value.value));
        }
        function isActiveValue(v) {
            const filter = (props.searchRequest.filters || []).find(isActiveFilter);
            if (!filter) {
                return false;
            }
            return (filter.values || []).find(val => val === v.valueCode || val === v.value);
        }
        function createActiveRange() {
            if (props.filter.type === 'date') {
                const activeFilter = (props.searchRequest.filters || []).find(isActiveFilter);
                if (activeFilter) {
                    const values = activeFilter.values || [];
                    return {
                        min: values.length === 0 ? null : values[0],
                        max: values.length === 0 ? null : values[values.length - 1],
                    };
                }
            }
            else if (isRangeFilter.value) {
                const activeFilter = (props.searchRequest.filters || []).find(isActiveFilter);
                if (activeFilter) {
                    return {
                        min: activeFilter.greaterThan || props.filter.min,
                        max: activeFilter.lessThan || props.filter.max,
                    };
                }
            }
            return {
                min: null,
                max: null,
            };
        }
        function createSelectedRange() {
            const range = createActiveRange();
            return {
                min: range.min === null ? props.filter.min : range.min,
                max: range.max === null ? props.filter.max : range.max,
            };
        }
        function isActiveFilter(filter) {
            return filter.property === props.filter.property || filter.property === props.filter.name;
        }
        function calculateTotalResults() {
            // date range
            if (props.filter.type === 'date') {
                const values = selectedDateRangeValues();
                if (values.length === 0) {
                    return 0;
                }
                return values.map(v => v.count).reduce((c1, c2) => c1 + c2);
            }
            // numeric range
            else if (isRangeFilter.value) {
                const selectedMin = selectedRange.value.min === null ? null : parseFloat('' + selectedRange.value.min);
                const selectedMax = selectedRange.value.max === null ? null : parseFloat('' + selectedRange.value.max);
                const values = props.filter.values
                    .filter(val => {
                    if (val.value === null) {
                        return false;
                    }
                    const valNumeric = parseFloat('' + val.value);
                    return (selectedMin === null || valNumeric >= selectedMin)
                        && (selectedMax === null || valNumeric <= selectedMax);
                });
                if (values.length === 0) {
                    return 0;
                }
                return values.map(v => v.count).reduce((c1, c2) => c1 + c2);
            }
            // text
            if (selectedValues.value.length === 0) {
                return 0;
            }
            return selectedValues.value.map(v => v.count)
                .reduce((c1, c2) => c1 + c2);
        }
        function selectedDateRangeValues() {
            const range = selectedRange.value;
            if (range.min === null && range.max === null) {
                return [];
            }
            const selectedMin = range.min === null ? null : Date.parse('' + range.min);
            const selectedMax = range.max === null ? null : Date.parse('' + range.max);
            return props.filter.values
                .filter(val => {
                if (val.value === null) {
                    return false;
                }
                const valDate = Date.parse('' + val.value);
                return (selectedMin === null || valDate >= selectedMin)
                    && (selectedMax === null || valDate <= selectedMax);
            });
        }
        function sortedFilterValues() {
            // values w/o results should come at the end
            const valuesWithResults = [];
            const valuesWithoutResults = [];
            props.filter.values.forEach(v => {
                if (v.count > 0) {
                    valuesWithResults.push(v);
                }
                else {
                    valuesWithoutResults.push(v);
                }
            });
            // apply custom filter config
            const filterConfig = portalConfig.catalog.search.filters[props.filter.name];
            if (filterConfig !== undefined) {
                valuesWithResults.sort(filterConfig.sort);
                valuesWithoutResults.sort(filterConfig.sort);
            }
            const sortedValues = [];
            valuesWithResults.forEach(v => sortedValues.push(v));
            valuesWithoutResults.forEach(v => sortedValues.push(v));
            return sortedValues;
        }
        function isBooleanFilterSelected() {
            if (props.filter.type !== 'bool') {
                return null;
            }
            const activeFilter = (props.searchRequest.filters || []).find(isActiveFilter);
            if (!activeFilter || activeFilter.values?.length === 0) {
                return null;
            }
            return activeFilter.values[0] === 'true'
                || activeFilter.values[0] === '1';
        }
        function isFilterHidden() {
            const filterConfig = portalConfig.catalog.search.filters[props.filter.name];
            return !!(filterConfig?.display && !filterConfig.display(props.filter));
        }
        function isFilterDisabled() {
            return !props.filter.values.find(v => v.count > 0);
        }
        function toggleDropdown() {
            showDropdown.value = !showDropdown.value && !disabled.value;
        }
        function isActive() {
            return activeValues.value.length > 0
                || activeRange.value.min !== null
                || activeRange.value.max !== null;
        }
        return (_ctx, _cache) => {
            return (!hidden.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["catalog-search-input-filter", {
                            'catalog-search-input-filter--active': active.value,
                            'catalog-search-input-filter--disabled': disabled.value
                        }]),
                    tabindex: disabled.value ? -1 : 0,
                    onKeyup: [
                        _withKeys(toggleDropdown, ["enter"]),
                        _withKeys(close, ["esc"])
                    ],
                    ref_key: "el",
                    ref: el
                }, [
                    _createElementVNode("a", {
                        onClick: _withModifiers(toggleDropdown, ["prevent"]),
                        class: "catalog-search-input-filter__button",
                        href: ""
                    }, [
                        _createElementVNode("div", {
                            class: "catalog-search-input-filter__label",
                            title: __props.filter.label
                        }, [
                            (__props.filter.type === 'bool')
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass({ 'catalog-search-input-filter__label-bool-true': activeBoolean.value === true, 'catalog-search-input-filter__label-bool-false': activeBoolean.value === false })
                                }, _toDisplayString(__props.filter.label), 3))
                                : (activeValues.value.length > 0)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        (__props.filter.type === 'date')
                                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(activeValues.value, (value, index) => {
                                                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                                    _createTextVNode(_toDisplayString(_ctx.$date(value.value)) + _toDisplayString(index < activeValues.value.length - 1 ? ', ' : ''), 1)
                                                ], 64));
                                            }), 128))
                                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(activeValues.value, (value, index) => {
                                                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                                    _createTextVNode(_toDisplayString(value.value || value.valueCode) + _toDisplayString(index < activeValues.value.length - 1 ? ', ' : ''), 1)
                                                ], 64));
                                            }), 128))
                                    ], 64))
                                    : (isRangeFilter.value && activeRange.value.min !== null || activeRange.value.max !== null)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                            _createTextVNode(_toDisplayString(__props.filter.label) + ": " + _toDisplayString(activeRange.value.min) + " – " + _toDisplayString(activeRange.value.max), 1)
                                        ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                            _createTextVNode(_toDisplayString(__props.filter.label), 1)
                                        ], 64))
                        ], 8, _hoisted_2),
                        _cache[6] || (_cache[6] = _createTextVNode()),
                        (!active.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createVNode(Icon, {
                                    name: "chevron-down",
                                    "icon-style": "light"
                                })
                            ]))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                onClick: _withModifiers(clear, ["stop", "prevent"]),
                                class: "catalog-search-input-filter__caret"
                            }, [
                                _createVNode(Icon, {
                                    name: "close",
                                    "icon-style": "light"
                                })
                            ]))
                    ]),
                    _cache[17] || (_cache[17] = _createTextVNode()),
                    (showDropdown.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, _toDisplayString(__props.filter.label), 1),
                            _cache[15] || (_cache[15] = _createTextVNode()),
                            (isRangeFilter.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("div", _hoisted_6, [
                                        _createElementVNode("a", {
                                            onClick: _withModifiers(clear, ["prevent"]),
                                            href: "",
                                            class: _normalizeClass(["catalog-search-input-filter__control", { 'catalog-search-input-filter__controls--disabled': selectedRange.value.min === null && selectedRange.value.max === null }])
                                        }, _toDisplayString(_ctx.$t('catalog.search_filter.clear')), 3)
                                    ]),
                                    _cache[10] || (_cache[10] = _createTextVNode()),
                                    _createElementVNode("div", {
                                        class: _normalizeClass(["catalog-search-input-filter__range", 'catalog-search-input-filter__range--' + props.filter.type])
                                    }, [
                                        _createElementVNode("div", _hoisted_7, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: rangeFilterInput.value,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedRange.value.min) = $event)),
                                                onChange: _cache[1] || (_cache[1] = ($event) => (rangeUpdated.value = true)),
                                                tabindex: "0",
                                                name: "min",
                                                class: "catalog-search-input-filter__range-input"
                                            }, null, 40, _hoisted_8), [
                                                [_vModelDynamic, selectedRange.value.min]
                                            ])
                                        ]),
                                        _cache[7] || (_cache[7] = _createTextVNode()),
                                        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "catalog-search-input-filter__range-value" }, "–", -1)),
                                        _cache[9] || (_cache[9] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_9, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: rangeFilterInput.value,
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((selectedRange.value.max) = $event)),
                                                onChange: _cache[3] || (_cache[3] = ($event) => (rangeUpdated.value = true)),
                                                tabindex: "0",
                                                name: "max",
                                                class: "catalog-search-input-filter__range-input"
                                            }, null, 40, _hoisted_10), [
                                                [_vModelDynamic, selectedRange.value.max]
                                            ])
                                        ])
                                    ], 2)
                                ], 64))
                                : (__props.filter.type === 'bool')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createElementVNode("div", _hoisted_11, [
                                            _createElementVNode("a", {
                                                onClick: _withModifiers(clear, ["prevent"]),
                                                href: ""
                                            }, _toDisplayString(_ctx.$t('catalog.search_filter.clear')), 1)
                                        ]),
                                        _cache[12] || (_cache[12] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_12, [
                                            _createElementVNode("label", _hoisted_13, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "radio",
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((selectedBoolean).value = $event)),
                                                    value: true,
                                                    name: 'filter-boolean--' + __props.filter.name,
                                                    tabindex: "0",
                                                    class: "catalog-search-input-filter__range-input"
                                                }, null, 8, _hoisted_14), [
                                                    [_vModelRadio, selectedBoolean.value]
                                                ]),
                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('catalog.search_filter.boolean_true')), 1)
                                            ]),
                                            _cache[11] || (_cache[11] = _createTextVNode()),
                                            _createElementVNode("label", _hoisted_15, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "radio",
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((selectedBoolean).value = $event)),
                                                    value: false,
                                                    name: 'filter-boolean--' + __props.filter.name,
                                                    tabindex: "0",
                                                    class: "catalog-search-input-filter__range-input"
                                                }, null, 8, _hoisted_16), [
                                                    [_vModelRadio, selectedBoolean.value]
                                                ]),
                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('catalog.search_filter.boolean_false')), 1)
                                            ])
                                        ])
                                    ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        _createElementVNode("div", _hoisted_17, [
                                            _createElementVNode("a", {
                                                onClick: _withModifiers(selectAll, ["prevent"]),
                                                href: ""
                                            }, _toDisplayString(_ctx.$t('catalog.search_filter.select_all')), 1),
                                            _cache[13] || (_cache[13] = _createTextVNode()),
                                            (selectedValues.value.length > 0)
                                                ? (_openBlock(), _createElementBlock("a", {
                                                    key: 0,
                                                    onClick: _withModifiers(clear, ["prevent"]),
                                                    href: ""
                                                }, _toDisplayString(_ctx.$t('catalog.search_filter.clear')), 1))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _cache[14] || (_cache[14] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_18, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterValues.value, (value, index) => {
                                                return (_openBlock(), _createBlock(CatalogSearchFilterInputValue, {
                                                    key: index,
                                                    filter: __props.filter,
                                                    value: value,
                                                    selected: isFilterValueSelected(value),
                                                    onToggle: ($event) => (toggleFilterValue(value))
                                                }, null, 8, ["filter", "value", "selected", "onToggle"]));
                                            }), 128))
                                        ])
                                    ], 64)),
                            _cache[16] || (_cache[16] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_19, [
                                (selectedValues.value.length > 0 || rangeUpdated.value || selectedBoolean.value !== null)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "button",
                                        onClick: _withModifiers(update, ["prevent"])
                                    }, _toDisplayString(totalResults.value === 0 ? _ctx.$t('catalog.search_filter.update') : _ctx.$t('catalog.search_filter.update_count', { count: totalResults.value })), 1))
                                    : (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        class: "button button--outline",
                                        onClick: _withModifiers(close, ["prevent"])
                                    }, _toDisplayString(_ctx.$t('catalog.search_filter.close')), 1))
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ], 42, _hoisted_1))
                : _createCommentVNode("", true);
        };
    }
});
